import {
  ColorCodes,
  colorsForTheme,
} from '@ordermentum/ui-shared/foundations/color';
import { Theme, genThemedStyled } from '@ordermentum/ui-shared/utilities/theme';
import { MEDIA_QUERIES as M } from '@ordermentum/ui-shared/foundations/grid';
import { FUTURO_TYPEFACES as F } from '@ordermentum/ui-shared/foundations/font';
import S from '@ordermentum/ui-shared/foundations/size';

type themeStyles = {
  color: ColorCodes;
  borderColor: ColorCodes;
  bannerColor: ColorCodes;
};

export const getTheme = (theme: Theme): themeStyles => {
  const colors = colorsForTheme(theme);
  const colorThemes = {
    color: colors.SPACE,
    borderColor: colors.SWEET_ORANGE,
    bannerColor: colors.SPACE,
  };
  return colorThemes;
};

export const ThemeStyled = genThemedStyled<themeStyles>();

export const Content = ThemeStyled.div({
  margin: 'auto',
  width: '70%',
  [M.TABLET_PORTRAIT_AND_SMALLER]: {
    width: '100%',
    padding: 0,
  },
});

export const InputContainer = ThemeStyled.div({
  input: {
    marginTop: S.XXS,
  },
  label: {
    marginTop: S.S,
    ...F.LABEL_SMALL,
  },
});

export const InputRow = ThemeStyled.div({
  display: 'grid',
  gridTemplateColumns: `repeat(2, minmax(6.25rem, 1fr))`,
  gridColumnGap: S.M,
});

export const InputRowField = ThemeStyled.div({
  display: 'block',
});

export const ErrorContainer = ThemeStyled.div(({ theme }) => ({
  marginTop: S.S,
  '> div': {
    color: theme.bannerColor,
  },
}));
